import * as Yup from 'yup';
import i18n from '../../translation/config';

export const authCodeValidationSchema = () =>
  Yup.object().shape({
    code: Yup.string()
      .length(6, 'Debe tener 6 dígitos')
      .matches(/^[0-9]+$/, 'Sólo números')
      .required('El código es requerido'),
  });

const loginValidationSchema = () =>
  Yup.object().shape({
    email: Yup.string().email(i18n.t('enter-valid-email')).required(i18n.t('email-required')),
    password: Yup.string().required(i18n.t('password-required')),
  });

export default loginValidationSchema;
